import React, { useState } from 'react';
import './EnquiryForm.css';

const EnquiryForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    projectType: '',
    message: ''
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: '', message: '' });

    // Using Web3Forms API - works immediately without setup
    // The access key is generated from your email address
    const recipientEmail = 'Sales@trivnu.com';

    try {
      // First, try to get access key from Web3Forms (this is a simple approach)
      // For immediate functionality, we'll use a direct email service

      // Using EmailJS as primary, but with a simpler fallback
      // Actually, let's use a service that works immediately

      // Using FormSubmit API which works without any setup
      const response = await fetch('https://formsubmit.co/ajax/Sales@trivnu.com', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          phone: formData.phone || 'Not provided',
          company: formData.company || 'Not provided',
          projectType: formData.projectType,
          message: formData.message,
          _subject: `Project Enquiry from ${formData.name}`,
          _template: 'box'
        })
      });

      const result = await response.json();

      if (response.ok || result.success) {
        setStatus({
          type: 'success',
          message: 'Thank you! Your enquiry has been sent successfully. We\'ll get back to you within 24 hours.'
        });

        // Reset form
        setFormData({
          name: '',
          email: '',
          phone: '',
          company: '',
          projectType: '',
          message: ''
        });
      } else {
        throw new Error('Failed to send email');
      }
    } catch (error) {
      console.error('Email Error:', error);

      // Fallback to mailto if API fails
      const emailBody = `
Name: ${formData.name}
Email: ${formData.email}
Phone: ${formData.phone || 'N/A'}
Company: ${formData.company || 'N/A'}
Project Type: ${formData.projectType}

Message:
${formData.message}
      `.trim();

      const mailtoLink = `mailto:${recipientEmail}?subject=Project Enquiry from ${encodeURIComponent(formData.name)}&body=${encodeURIComponent(emailBody)}`;

      setStatus({
        type: 'info',
        message: 'Opening your email client. Please send the message to complete your enquiry.'
      });

      // Open email client after a brief delay
      setTimeout(() => {
        window.location.href = mailtoLink;
      }, 500);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="enquiry" className="enquiry">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Request a Quote</h2>
          <p className="section-description">
            Get in touch with us to discuss your project requirements. We'll get back to you within 24 hours.
          </p>
        </div>

        <div className="enquiry-content">
          <div className="enquiry-info">
            <h3>Let's Start Your Project</h3>
            <p>
              Fill out the form and our team will review your requirements and provide
              a customized quote for your project.
            </p>
            <div className="contact-info">
              <div className="contact-item">
                <div className="contact-icon">📧</div>
                <div>
                  <strong>Email</strong>
                  {/* <a href="mailto:Sales@trivnu.com" onclick="openEmailPopup(event)">
                    📧 Email: Sales@trivnu.com
                  </a> */}
                  <p onClick={() => window.location.href = 'mailto:Sales@trivnu.com'}>Sales@trivnu.com</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">📱</div>
                <div>
                  <strong>Phone</strong>
                  <p>+91 (702) 166-8565</p>
                  <p>+91 (858) 283-2409</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">🕒</div>
                <div>
                  <strong>Business Hours</strong>
                  <p>Mon - Fri : 9:00 AM - 6:00 PM (IST)</p>
                  <p>Mon - Fri : 9:00 AM - 6:00 PM (GMT)</p>
                  <p>Mon - Fri : 9:00 AM - 6:00 PM (CET)</p>
                  <p>Mon - Fri : 9:00 AM - 6:00 PM (EST)</p>
                  <p>Mon - Fri : 9:00 AM - 6:00 PM (PST)</p>
                  <p>Mon - Fri : 9:00 AM - 6:00 PM (MST)</p>
                  <p>Mon - Fri : 9:00 AM - 6:00 PM (CST)</p>
                  <p>Mon - Fri : 9:00 AM - 6:00 PM (NST)</p>
                  <p>Mon - Fri : 9:00 AM - 6:00 PM (AST)</p>
                  <p>Mon - Fri : 9:00 AM - 6:00 PM (HST)</p>
                  <p>Mon - Fri : 9:00 AM - 6:00 PM (AKST)</p>
                </div>
              </div>
            </div>
          </div>

          <form className="enquiry-form" onSubmit={handleSubmit}>
            {status.message && (
              <div className={`form-status ${status.type}`}>
                {status.message}
              </div>
            )}

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="John Doe"
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="john@example.com"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="+1 (555) 123-4567"
                />
              </div>
              <div className="form-group">
                <label htmlFor="company">Company Name</label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  placeholder="Your Company"
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="projectType">Project Type *</label>
              <select
                id="projectType"
                name="projectType"
                value={formData.projectType}
                onChange={handleChange}
                required
              >
                <option value="">Select a project type</option>
                <option value="web-development">Web Development</option>
                <option value="mobile-app">Mobile Application</option>
                <option value="e-commerce">E-Commerce</option>
                <option value="custom-software">Custom Software</option>
                <option value="consulting">Consulting</option>
                <option value="other">Other</option>
              </select>
            </div>

            <div className="form-group">
            
              <label htmlFor="message">Project Details *</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="5"
                placeholder="Tell us about your project requirements, timeline, and any specific needs..."
              ></textarea>
            </div>

            <button
              type="submit"
              className="submit-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : 'Send Enquiry'}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default EnquiryForm;
